var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiatCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8928 16.0225H13.1102C13.1102 20.849 9.1976 24.7616 4.37109 24.7616V42.2399C9.1976 42.2399 13.1102 46.1525 13.1102 50.979H53.8928C53.8928 46.1525 57.8055 42.2399 62.632 42.2399V24.7616C57.8055 24.7616 53.8928 20.849 53.8928 16.0225Z",
    fill: "url(#paint0_linear_1429_5160)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 55.348H1.45652C0.652158 55.348 0 54.6958 0 53.8915V13.1089C0 12.3045 0.652158 11.6523 1.45652 11.6523H65.5435C66.3478 11.6523 67 12.3045 67 13.1089V53.8915C67 54.6958 66.3478 55.348 65.5435 55.348Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 55.348H1.45652C0.652158 55.348 0 54.6958 0 53.8915V13.1089C0 12.3045 0.652158 11.6523 1.45652 11.6523H65.5435C66.3478 11.6523 67 12.3045 67 13.1089V53.8915C67 54.6958 66.3478 55.348 65.5435 55.348Z",
    fill: "url(#paint1_linear_1429_5160)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 54.748H1.45652C0.983528 54.748 0.6 54.3645 0.6 53.8915V13.1089C0.6 12.6359 0.983528 12.2523 1.45652 12.2523H65.5435C66.0165 12.2523 66.4 12.6359 66.4 13.1089V53.8915C66.4 54.3645 66.0165 54.748 65.5435 54.748Z",
    stroke: "url(#paint2_linear_1429_5160)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1429_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8928 16.0225H13.1102C13.1102 20.849 9.1976 24.7616 4.37109 24.7616V42.2399C9.1976 42.2399 13.1102 46.1525 13.1102 50.979H53.8928C53.8928 46.1525 57.8055 42.2399 62.632 42.2399V24.7616C57.8055 24.7616 53.8928 20.849 53.8928 16.0225Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1429_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5003 43.696C39.1312 43.696 43.696 39.1312 43.696 33.5003C43.696 27.8694 39.1312 23.3047 33.5003 23.3047C27.8694 23.3047 23.3047 27.8694 23.3047 33.5003C23.3047 39.1312 27.8694 43.696 33.5003 43.696Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5160",
    x: -24,
    y: -12.3477,
    width: 115,
    height: 91.6953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5160",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1429_5160",
    x: 4.37109,
    y: 16.0225,
    width: 58.2607,
    height: 42.9561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1429_5160",
    x: 23.3047,
    y: 23.3047,
    width: 20.3916,
    height: 28.3916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5160",
    x1: 6.79863,
    y1: 23.0138,
    x2: 68.2406,
    y2: 37.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5160",
    x1: 2.79167,
    y1: 20.3915,
    x2: 74.0063,
    y2: 35.5576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5160",
    x1: 2.09375,
    y1: 13.6385,
    x2: 67,
    y2: 13.6385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiatCash);
export default __webpack_public_path__ + "static/media/fiat-cash.ed530331c3a0f61c0dd1b6b88b32888f.svg";
export { ForwardRef as ReactComponent };